import { app as firebaseApp } from '.';
import { getFirestore } from 'firebase/firestore';

export const db = getFirestore(firebaseApp);
